setInterval(function () {$('.rb-options .tflex-wrap select').each(function (key, value){
    $(this).addClass('rbselect'+ key);
})}, 1000);
  setInterval(function () {
jQuery(document).on('change',".rbselect0", function() {
    $(".rb-options").append('<p class="valid"><em>Please Select Veggie Slices</em></p>'); 
    event.preventDefault();
    $("#product-variant-list").focus();  
     $(".button.rb-btn.tnowrap").prop("disabled", true);
  
});
  }, 1000); 
jQuery(document).on('change',".rbselect1", function() {
  $(".valid").remove();
});

  setInterval(function () {
     $('.rb-btn-qty-plus').on('click', function() { 
    $("button.rb-btn.tnowrap").prop("disabled", true);
       
    // selectVal = $('.rbselect1').val();
    //    if (selectVal == '0') {
    //      $("button.rb-btn.tnowrap").prop("disabled", true);
    // }else { 
    //      $("button.rb-btn.tnowrap").prop("disabled", false);
      
    // }
  $('.rbselect1').change(function () {
    selectVal = $('.rbselect1').val();  
    if (selectVal == '0') {
         $("button.rb-btn.tnowrap").prop("disabled", true);
    }
    else { 
         $("button.rb-btn.tnowrap").prop("disabled", false);
      
    }
  })
            
});
  }, 2000); 
 
  // $('.rbselect1').val("0");
  //   selectVal = $('.rbselect1').val();
  // alert('selectVal',selectVal)
   
  //   if (selectVal == '') {
  //        $("button.rb-btn.tnowrap").prop("disabled", true);
  //   }
  // $('.rbselect1').change(function () {
  //   selectVal = $('.rbselect1').val();
  // alert('selectVal',selectVal)
   
  //   if (selectVal == '') {
  //        $("button.rb-btn.tnowrap").prop("disabled", true);
  //   }
  //   else { 
  //        $("button.rb-btn.tnowrap").prop("disabled", false);
      
  //   }
  // })
  

 

// jQuery(document).on('change',"#product-variant-list", function() {
      // if ($("#product-variant-list option:selected").val()=='')
      //   {
      //     event.preventDefault();
      //     $("#product-variant-list").focus();
      //     $(".rb-form").append('<p class="valid"><em>Please Select something</em></p>');
      //      $(":submit").prop("disabled", true);
      //   }

      // Check if submit is disabled on change of select

      
      // jQuery(this).parent().siblings('.tflex-wrap').find('select').val(jQuery(this).parent().siblings('.tflex-wrap').find('select option').val());
      
    // });
    
     jQuery(document).on('click','.template--new-recharge-bundle-utk', function (){
      
          jQuery('#product-variant-list').val(jQuery('#product-variant-list option:selected').val());
          // jQuery('#product-variant-list').parent().siblings('.tflex-wrap').find('select').val(jQuery('#product-variant-list').parent().siblings('.tflex-wrap').find('select option:first').val());
           console.log('jdjdlkjd ',jQuery(this).siblings('.rb-input').val());
           // const myTimeout = setTimeout(myGreeting, 8000);
           // function myGreeting() {
             var count = 0;
                $('.rb-qty-wrapper .rb-input').each(function (){
                  if($(this).val() > 0)
                    count += +$(this).val() 
                  
                })
             console.log(count)
             if(10 > count){
               // count -= 10;
                $("button.rb-btn.tnowrap").prop("disabled", true);
               
               $('.pick-text #yo_chapi').text(10-count).parent().show();
                count = 0; 
                temp=0;
             }else {
                $("button.rb-btn.tnowrap").prop("disabled", false);
               
               $('.pick-text').hide();
             } 
                 
           //     clearTimeout(myTimeout);
           // }
           // }
        })
 
//  $(document).on('click','.template--new-recharge-bundle-utk .rb-item-actions .rb-qty-wrapper button', function (){

//    if($(this).siblings('.rb-input').val() == 3){
//       console.log('true jdjdlkjd ',this.value);
//    }else{
//      console.log('false');
//    }
// // function myGreeting() {
//    $('#product-variant-list').val($('#product-variant-list option:selected').val());
//       $('#product-variant-list').parent().siblings('.tflex-wrap').find('select').val($('#product-variant-list').parent().siblings('.tflex-wrap').find('select option:first').val());
// //   clearTimeout(myTimeout);
// // }

    
//   // console.log('jdjdlkjd ',this.value);
// })
 